<div class="category-body-option flex row align-center justify-between" [class.disabled]="!option.enabled" [class.selected]="option?.IsSelected"
     (click)="handleOptionSelect()">
    <div class="label-container">
        {{option.Name}}</div>
    <div class="icon-container">
        <icon name="success"></icon>
    </div>
</div>